export default "__VITE_ASSET__Fo5BciIj__"